import styled from '@emotion/styled';
import ArrowLongDown from '../../../../assets/svg/arrow-long-down.svg';
import { Color, colors } from '../../../../utils/styleguide';

export const ScrollHintArrow = styled(ArrowLongDown)<{
  color: Color;
  style: Record<string, string>;
}>`
  display: block;
  margin: 0 auto;
  width: 24px;
  height: 24px;
  stroke: ${({ color }: { color: Color }) => colors[color] || colors.yellow};
  stroke-width: 2px;
  ${({ style }) => style};
`;
